// src/utils/formVisibility.js
export function get(obj, path) {
  return path.split('.').reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
}

export function isVisible(field, values) {
  const rule = field.visibleWhen;
  if (!rule) return true;
  const v = get(values, rule.field);
  if ('equals' in rule) return v === rule.equals;
  if ('notEquals' in rule) return v !== rule.notEquals;
  if ('in' in rule) return Array.isArray(rule.in) && rule.in.includes(v);
  if (typeof rule.predicate === 'function') {
    try {
      return !!rule.predicate(values);
    } catch {
      return false;
    }
  }
  return true;
}

export function applyVisibility(structure, values) {
  return structure.filter((f) => isVisible(f, values));
}
